module.exports = __webpack_public_path__ + "static/media/icon-check-mark-green.9bdaa437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-check-mark-green.svg
// module id = 343
// module chunks = 0